import { createSelector } from "reselect";

const getVideoId = (state, ownProps) => ownProps.videoId;
const getVideosEntity = (state) => state.story.entities.videos;

export const makeGetVideoEntity = () =>
  createSelector(
    [getVideoId, getVideosEntity],
    (videoId, videosEntity) => videosEntity[videoId],
  );

export default makeGetVideoEntity;
